import { useAuth } from '@berky/auth'
import { LoadingSkeleton } from '@berky/ui'
import { lazy, Suspense } from 'react'
import { Navigate } from 'react-router'

import { FEEDBACK_ROLE } from './feedback-constants'
import { ModuleErrorBoundary } from '../layout/module-error-boundary'
import { roleAccess } from '../module-access'

const FeedbackWorkspacePage = lazy(async () => {
  const loaded = await import('./management/pages/feedback-workspace')
  return { default: loaded.FeedbackWorkspacePage }
})

/** Explizit registrierter Plattformzugang zur Feedbackverwaltung. */
export function FeedbackManagementRoute() {
  const { user, isLoading } = useAuth()
  const access = roleAccess(user?.roles, [FEEDBACK_ROLE])

  if (isLoading || access === 'unbekannt') {
    return <LoadingSkeleton variant="text" rows={6} />
  }

  if (access !== 'erlaubt') {
    return <Navigate to="/forbidden" replace state={{ moduleTitle: 'Feedback' }} />
  }

  return (
    <ModuleErrorBoundary moduleId="feedback" moduleTitle="Feedback" platformFeature>
      <Suspense fallback={<LoadingSkeleton variant="text" rows={6} />}>
        <FeedbackWorkspacePage />
      </Suspense>
    </ModuleErrorBoundary>
  )
}
